import React, { useContext } from 'react';
import { fromJS } from 'immutable';

import HeaderMeta from '../../../components/HeaderMeta';
import { paths } from '../../../paths';
import { useDateToString } from '../../../components/Element/DateToString';
import { useRouter } from '../../../hooks';
import { AppContext } from '../../../store/App';

const SessionRegisterMeta = ({ session }) => {
  const {
    generateUrl,
    currentRoute: { params },
  } = useRouter();
  const { country } = useContext(AppContext);
  const DateToString = useDateToString();
  const image = {
    url: require('../../../assets/images/banner/session-search/mobile.jpg'),
    dimensions: {
      width: 350,
      height: 350,
    },
  };

  const transParam = {
    testTypeFamilyName: session.getIn(['testTypeFamily', 'name']),
    city: session.get('testingSite') ? session.get('testingSite').get('address').get('city') : null,
    date: DateToString({ date: session.get('scheduledAt'), format: 'dddd LL', timezone: session.get('timeZone') }),
    startTime: DateToString({
      date: session.get('startAt'),
      timezone: session.get('timeZone'),
      format: 'LT',
    }),
    endTime: DateToString({
      date: session.get('endAt'),
      timezone: session.get('timeZone'),
      format: 'LT',
    }),
    seatAvailable: session.get('seatsAvailable'),
  };

  const testTypeCountry = session.get('testingSite')
    ? session.get('testingSite').get('address').get('country')
    : fromJS(country);

  return (
    <HeaderMeta
      page={session.get('testingSite') ? 'session-registration' : 'online-session-registration'}
      meta={{
        image,
        canonical: generateUrl(paths.SESSION_REGISTER, {
          ...params,
          country:
            testTypeCountry && testTypeCountry.get('iso2') ? testTypeCountry.get('iso2').toLowerCase() : params.country,
        }),
      }}
      transParam={transParam}
    />
  );
};

export default SessionRegisterMeta;
